import { ApiSummaryStatus, ApiRunConfigStatus } from './enumerations';

export const API_ERROR_MESSAGES = {
  UNKNOWN_ERROR: 'Unknown error. Please try again later.',
  SERVICE_UNAVAILABLE: 'Service is currently unavailable. Please try again later.',
  TOO_MANY_REQUESTS:
    'It looks like our system is receiving too many requests at the moment. Please wait a few moments and try again.',
  MAX_TOKENS_EXCEEDED: 'File size exceeds system processing. Please upload a smaller file.',
  UPLOAD_ERROR: 'Upload Failed',
  SUMMARY_STATUS_ERROR:
    'Something went wrong! We encountered an unexpected issue while processing your request.',
  REQUEST_CANCELED: 'Request canceled',
  NETWORK_ERROR: 'A network error occurred while processing your request.',
};

export const MAX_PART_SIZE = 100 * 1024 * 1024; // 100MB

export const MAX_FILE_SIZE = 200 * 1024 * 1024; // 200MB
export const SUPPORT_DOWNLOAD_FORMATS = ['.csv', '.xls', '.xlsx', '.pdf'];

export const SALES_OUTCOME_TABLE_FIELDS = [
  { label: 'Loan Advisor Name', key: 'sales_outcome_loan_advisor_name' },
  { label: 'Current Rate (%)', key: 'sales_outcome_current_rate_percent' },
  { label: 'Offered Rate (%)', key: 'sales_outcome_offered_rate_percent' },
  { label: 'Savings ($)', key: 'sales_outcome_savings_dollars' },
  { label: 'Offer Accepted? (Y/N)', key: 'sales_outcome_offer_accepted_yn' },
  { label: 'Reason for accepting if mentioned?', key: 'sales_outcome_reason_for_accepting' },
  { label: 'Accept Category', key: 'sales_outcome_accept_category' },
  { label: 'Offer Declined? (Y/N)', key: 'sales_outcome_offer_declined_yn' },
  { label: 'Decline Reason', key: 'sales_outcome_decline_reason' },
  { label: 'Decline Category', key: 'sales_outcome_decline_category' },
  { label: 'Borrower objections? (Y/N)', key: 'sales_outcome_borrower_objections_yn' },
  { label: 'Objection Category', key: 'sales_outcome_objection_category' },
  { label: 'Objections overcome? (Y/N)', key: 'sales_outcome_objections_overcome_yn' },
  { label: 'Objections overcome Category', key: 'sales_outcome_objections_overcome_category' },
  {
    label: 'Competitive offer mentioned? (Y/N)',
    key: 'sales_outcome_competitive_offer_mentioned_yn',
  },
  { label: 'Company with the competitive offer', key: 'sales_outcome_competitive_offer_company' },
  { label: 'Competitive offer (% and points)', key: 'sales_outcome_competitive_offer_details' },
  { label: 'Pitch made? (Y/N)', key: 'sales_outcome_pitch_made_yn' },
  { label: 'Other commentary about the script', key: 'sales_outcome_script_commentary' },
];

export const FAILED_SUMMARY_STATUSES = [
  ApiSummaryStatus.SummarizationFailure,
  ApiSummaryStatus.FlattenFailure,
] as string[];

export const FINAL_SUMMARY_STATUSES = [
  ApiSummaryStatus.SummarizationSavedOnline,
  ...FAILED_SUMMARY_STATUSES,
] as string[];

export const FINAL_RUN_CONFIG_STATUSES = [
  ApiRunConfigStatus.Completed,
  ApiRunConfigStatus.Failed,
] as string[];

export const DIALOG_SUCCESS_UPLOAD_MESSAGE =
  'Your file has been successfully uploaded. The summarization process may take a few more minutes. Please check the status in the table.';

export const VALID_FILE_TYPES = ['audio/wav', 'audio/x-wav', 'audio/mpeg', 'video/mp4'];

export const MINIMUM_VISIBLE_COUNT = 10;

export const MAX_WIDTHS = {
  TRANSCRIPTION_CONTENT: 792,
  SALES_TABLE_CELL_FILE_NAME: 570,
  COMPLIANCE_TABLE_CELL_FILE_NAME: 250,
  FOOTER: 202,
};

export const MAX_HEIGHTS = {
  SECTION_CONTENT: 790,
  SUBHEADER: 70,
};

export const MIN_WIDTHS = {
  DOWNLOAD_SUMMARY_BUTTON: 190,
};

export const MAX_PDF_SIZE = 100 * 1024 * 1024; // 100MB

export const ACCEPTED_AUDIO_FILE_TYPES = {
  'audio/*': ['.mp3', '.wav'],
  'video/*': ['.mp4'],
};

export const EMPTY_CONTENT_MESSAGES = {
  CALL_TRANSCRIPTION: 'No Call Transcription data to display',
  SUMMARYTABLE: 'No Summary data to display',
  DEMOGRAPHICS: 'No Demographics data to display',
  SCRIPT_ADHERENCE: 'No Script Adherence data to display',
  FORM_1003: 'No Form 1003 data to display',
};

export const ERROR_MESSAGES = {
  NO_PDF_UPLOADED: 'Audio file cannot be compared as there is no PDF uploaded',
};

export const MSAL_SCOPES = ['profile openid email User.Read'];
